import Logo from '@/components/shared/Logo'
import ScrollToTopLink from '@/components/shared/ScrollToTopLink'

const DesktopFooter = () => {
  return (
    <div className="hidden lg:block">
      <div className="container mx-auto max-w-[90%] py-12 lg:max-w-[85%] xl:max-w-[80%]">
        <div className="mb-6 grid grid-cols-1 items-start gap-6 sm:mb-8 sm:grid-cols-2 sm:gap-8 md:grid-cols-4">
          <div className="flex flex-col items-center sm:items-start">
            <div className="mb-4 sm:mb-6">
              <Logo variant="footer" />
            </div>
          </div>

          <div className="text-center">
            <h3 className="mb-3 inline-block border-b border-[#F4A261] pb-2 text-base font-semibold text-white sm:mb-4 sm:text-lg">
              ADDRESS
            </h3>
            <div className="space-y-1 text-white">
              <p>Your Claim Matters</p>
              <p className="font-raleway-numbers">84 Salop Street</p>
              <p>Wolverhampton</p>
              <p className="font-raleway-numbers">WV3 0SR</p>
            </div>
          </div>

          <div className="text-center">
            <h3 className="mb-3 inline-block border-b border-[#F4A261] pb-2 text-base font-semibold text-white sm:mb-4 sm:text-lg">
              INFORMATION
            </h3>
            <ul className="space-y-1">
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/faqs"
                >
                  FAQs
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/about-us"
                >
                  About Us
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/contact"
                >
                  Contact Us
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/mlm-information-and-key-facts"
                >
                  Key Facts
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/referral-program"
                >
                  Referral Program
                </ScrollToTopLink>
              </li>
            </ul>
          </div>

          <div className="text-center">
            <h3 className="mb-3 inline-block border-b border-[#F4A261] pb-2 text-base font-semibold text-white sm:mb-4 sm:text-lg">
              POLICIES
            </h3>
            <ul className="space-y-1">
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/terms-and-conditions"
                >
                  Terms and Conditions
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/privacy-policy"
                >
                  Privacy Policy
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/cookie-policy"
                >
                  Cookie Policy
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/terms-of-use"
                >
                  Terms of Use
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/complaints-procedure"
                >
                  Complaints Procedure
                </ScrollToTopLink>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-4">
          <p className="mb-2 text-center text-xs text-white/75">
            Your Claim Matters head office address: 84 Salop Street,
            Wolverhampton, WV3 0SR, United Kingdom.
          </p>
          <p className="mb-4 text-center text-xs text-white/75">
            Your Claim Matters is a claims management company and is a trading
            style of Victor Hydon Ltd, Swinford House, Albion St, Brierley Hill
            DY5 3EE and is registered in England and Wales (Company No 09086740)
            VAT registration number 204 1226 68. Victor Hydon Ltd is regulated
            by the Financial Conduct Authority (Firm reference number: 833758).
            These details can be confirmed by visiting the Financial Services
            Register, www.fca.org.uk/register.
          </p>
          <p className="font-raleway-numbers text-center text-xs text-white/80">
            Copyright 2026 Your Claim Matters. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  )
}

export default DesktopFooter
